import BaseMapController from "../common/map/base_map_controller";
import {FeatureLike} from "ol/Feature";
import {Feature} from "ol";
import {Style} from "ol/style";
import {fromLonLat} from "ol/proj";
import {Point} from "ol/geom";
import {defaultIconStyle} from "../common/map/defaultIconStyle";

export default class extends BaseMapController<{ location: { lat: number, lon: number }, ids: number[] }> {
  protected getFeatureStyle(feature: FeatureLike): Style {
    return defaultIconStyle;
  }

  protected featureClickHandler(features: FeatureLike[]): void {
    const eventOccurrenceIds: number[] = features?.map((feature) => feature.get('event_occurrence_ids')).flat();
    if (!eventOccurrenceIds.length) return;

    this.element.dispatchEvent(
      new CustomEvent("map-point-selected", { detail: eventOccurrenceIds, bubbles: true })
    );
  }
  protected async loadPoints(params: URLSearchParams): Promise<{ location: { lat: number, lon: number }, ids: number[] }[]> {
    let requestUrl = `points?${params.toString()}`;

    const response = await fetch(requestUrl);
    return response.json();
  }
  protected pointToFeature(point: { location: { lat: number, lon: number }, ids: number[] }): Feature {
    const feature = new Feature({
      geometry: new Point(fromLonLat([point.location.lon, point.location.lat]))
    });

    feature.set("event_occurrence_ids", point.ids);

    return feature;
  }
}
